import { useTitle } from "../../hooks";

const Title: React.FC<{title: string}> = ({title}) => {
    useTitle(title);
    return null;
};

export default Title;
